// extracted by mini-css-extract-plugin
export default {"tag":"tag--kYveT","ellipsis":"ellipsis--uJEH9"};